import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/events',
    name: 'Events',
    component: () => import('@/views/Events'),
  },
  {
    path: '/play/:event',
    name: 'Play',
    component: () => import('@/views/Play'),
  },
  {
    path: '/creator',
    name: 'Creator',
    component: () => import('@/views/Creator'),
  },
  {
    path: '/lockdown',
    name: 'Competition Home',
    component: () => import('@/views/CompetitionHome'),
  },
  {
    path: '/lockdown/view-routes',
    name: 'Competition View Routes',
    component: () => import('@/views/CompetitionViewRoutes'),
  },
  {
    path: '/lockdown/play',
    name: 'Competition Game',
    component: () => import('@/views/CompetitionGame'),
  },
  {
    path: '/lockdown/results',
    name: 'Competition Results',
    component: () => import('@/views/CompetitionResults'),
  },
  {
    path: '/requirements-test',
    name: 'Requirements Test',
    component: () => import('@/views/RequirementsTest'),
  },

  {
    path: '/sejs',
    name: 'SEJS Home',
    component: () => import('@/views/SEJSHome'),
  },
  {
    path: '/sejs/play',
    name: 'SEJS Game',
    component: () => import('@/views/SEJSGame'),
  },
  {
    path: '/sejs/view-routes',
    name: 'SEJS View Routes',
    component: () => import('@/views/SEJSViewRoutes'),
  },
  {
    path: '/sejs/results',
    name: 'SEJS Results',
    component: () => import('@/views/SEJSResults'),
  },

  {
    path: '/teams',
    name: 'Teams Home',
    component: () => import('@/views/TeamsHome'),
  },
  {
    path: '/teams/play',
    name: 'Teams Game',
    component: () => import('@/views/TeamsGame'),
  },
  {
    path: '/teams/view-routes',
    name: 'Teams View Routes',
    component: () => import('@/views/TeamsViewRoutes'),
  },

  {
    path: '*',
    name: 'Home',
    component: Home,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
